import { Link } from 'react-router-dom';

export default function PharmacistSafetyCheckPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-capsule-fill text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>logo</span>
            </Link>
            <nav className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">ホーム</Link>
              <Link to="/services" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">サービス</Link>
              <Link to="/beast-blog" className="text-teal-600 font-medium whitespace-nowrap">ビースト君ブログ</Link>
              <Link to="/contact" className="bg-teal-600 text-white px-6 py-2 rounded-full hover:bg-teal-700 transition-colors whitespace-nowrap">お問い合わせ</Link>
            </nav>
            <button className="md:hidden w-10 h-10 flex items-center justify-center">
              <i className="ri-menu-line text-2xl text-gray-600"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Article Header */}
      <div className="bg-gradient-to-br from-red-50 to-orange-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 mb-4">
            <span className="bg-red-600 text-white px-3 py-1 rounded-full text-sm font-medium whitespace-nowrap">緊急</span>
            <span className="text-gray-600 text-sm">2025年11月16日</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            🚨 【命を守る目】薬剤師があなたのお薬手帳を見て「即、疑義照会！」する危険なサイン3選
          </h1>
          <div className="flex flex-wrap gap-2 mb-6">
            <span className="bg-white text-gray-700 px-4 py-2 rounded-full text-sm border border-gray-200 whitespace-nowrap">お薬手帳</span>
            <span className="bg-white text-gray-700 px-4 py-2 rounded-full text-sm border border-gray-200 whitespace-nowrap">疑義照会</span>
            <span className="bg-white text-gray-700 px-4 py-2 rounded-full text-sm border border-gray-200 whitespace-nowrap">薬剤師チェック</span>
            <span className="bg-white text-gray-700 px-4 py-2 rounded-full text-sm border border-gray-200 whitespace-nowrap">重複投薬</span>
            <span className="bg-white text-gray-700 px-4 py-2 rounded-full text-sm border border-gray-200 whitespace-nowrap">薬の飲み合わせ</span>
            <span className="bg-white text-gray-700 px-4 py-2 rounded-full text-sm border border-gray-200 whitespace-nowrap">医療安全</span>
            <span className="bg-white text-gray-700 px-4 py-2 rounded-full text-sm border border-gray-200 whitespace-nowrap">相互作用</span>
          </div>
          <p className="text-xl text-gray-700 leading-relaxed">
            複数の病院にかかっている方、複数の薬を服用している方へ。薬剤師が最後の砦として、あなたの命を守るために行っている重要なチェックポイントをご紹介します。
          </p>
        </div>
      </div>

      {/* Article Content */}
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Introduction */}
        <section className="mb-16">
          <div className="bg-red-50 border-l-4 border-red-600 p-6 mb-8 rounded-r-lg">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <i className="ri-alert-fill text-red-600 mr-3"></i>
              なぜお薬手帳が「命綱」なのか
            </h2>
          </div>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              「複数の病院にかかっているけれど、飲み合わせは大丈夫？」<br />
              「もしかして、薬が増えすぎている？」
            </p>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              このような不安を抱えている方は少なくありません。実は、薬剤師は単に薬を渡す人ではありません。<strong>最後の砦として、「この薬の組み合わせは危険ではないか」という【命を守る目】でダブルチェックを行っています。</strong>
            </p>

            <div className="bg-gradient-to-r from-teal-50 to-blue-50 p-8 rounded-xl mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-shield-check-fill text-teal-600 mr-3"></i>
                薬剤師の重要な役割
              </h3>
              <p className="text-gray-700 leading-relaxed">
                特に「すぐに医師に確認しなければならない（疑義照会）」と判断する、見過ごせない危険なサインがあります。今回は、その中でも特に重要な3つのサインを具体的に解説し、お薬手帳の重要性を再認識していただきます。
              </p>
            </div>
          </div>
        </section>

        {/* Main Content - 3 Signs */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            薬剤師が即座に介入する「危険なサイン3選」
          </h2>

          {/* Sign 1 */}
          <div className="mb-12 bg-white border-2 border-red-200 rounded-2xl overflow-hidden shadow-lg">
            <div className="bg-gradient-to-r from-red-600 to-orange-600 text-white p-6">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-3xl font-bold">1</span>
                </div>
                <h3 className="text-2xl font-bold">同じ効果の薬が重複している（重複投薬）</h3>
              </div>
            </div>
            <div className="p-8">
              <div className="mb-6">
                <h4 className="text-xl font-bold text-red-600 mb-3 flex items-center">
                  <i className="ri-error-warning-fill mr-2"></i>
                  危険性
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  意図せず薬の量が倍になり、過剰な効果や副作用の出現リスクが大幅に高まります。例えば、同じ成分の痛み止めを2種類飲んでいる場合、肝臓や腎臓への負担が倍増し、重篤な障害を引き起こす可能性があります。
                </p>
              </div>

              <div className="mb-6 bg-teal-50 p-6 rounded-xl">
                <h4 className="text-xl font-bold text-teal-700 mb-3 flex items-center">
                  <i className="ri-user-star-fill mr-2"></i>
                  薬剤師の行動
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  お薬手帳の履歴から重複を特定し、「いつ」「どの病院から」出ているかを確認。医師に一元化または中止を提案します。複数の医療機関を受診している場合でも、薬剤師がしっかりと情報を統合し、安全性を確保します。
                </p>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl">
                <h4 className="text-xl font-bold text-blue-700 mb-3 flex items-center">
                  <i className="ri-lightbulb-fill mr-2"></i>
                  患者さんへのアドバイス
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  薬局で薬を受け取る際、必ず「他に飲んでいる薬」を伝えることが重要です。お薬手帳を毎回持参し、すべての薬の情報を一元管理しましょう。
                </p>
              </div>
            </div>
          </div>

          {/* Sign 2 */}
          <div className="mb-12 bg-white border-2 border-orange-200 rounded-2xl overflow-hidden shadow-lg">
            <div className="bg-gradient-to-r from-orange-600 to-yellow-600 text-white p-6">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-3xl font-bold">2</span>
                </div>
                <h3 className="text-2xl font-bold">服用を始めたばかりの薬と「飲み合わせの悪い薬」の組み合わせ（相互作用）</h3>
              </div>
            </div>
            <div className="p-8">
              <div className="mb-6">
                <h4 className="text-xl font-bold text-orange-600 mb-3 flex items-center">
                  <i className="ri-error-warning-fill mr-2"></i>
                  危険性
                </h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  ある薬が、別の薬の効果を強めすぎたり、弱めすぎたりするリスクがあります。特に、血液を固まりにくくする薬や、特定の感染症の薬などは要注意。重篤な出血や薬効の消失につながる可能性があります。
                </p>
                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded-r-lg">
                  <p className="text-gray-700 leading-relaxed">
                    <strong>具体例：</strong>「このAという薬と、Bという種類の薬を一緒に飲むと、体内で薬が分解されずに溜まってしまい、危険な状態になることがあります。」
                  </p>
                </div>
              </div>

              <div className="mb-6 bg-teal-50 p-6 rounded-xl">
                <h4 className="text-xl font-bold text-teal-700 mb-3 flex items-center">
                  <i className="ri-user-star-fill mr-2"></i>
                  薬剤師の行動
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  最新の処方箋と過去のお薬手帳の履歴を照合し、リスクが高い組み合わせを検知。安全な代替案を医師に提案し、患者さんの安全を最優先に考えます。専門的なデータベースを活用し、最新の相互作用情報も常にチェックしています。
                </p>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl">
                <h4 className="text-xl font-bold text-blue-700 mb-3 flex items-center">
                  <i className="ri-lightbulb-fill mr-2"></i>
                  患者さんへのアドバイス
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  新しい薬を処方された際は、必ず現在服用中のすべての薬（市販薬やサプリメントも含む）を薬剤師に伝えましょう。些細なことでも、命を守る重要な情報になります。
                </p>
              </div>
            </div>
          </div>

          {/* Sign 3 */}
          <div className="mb-12 bg-white border-2 border-purple-200 rounded-2xl overflow-hidden shadow-lg">
            <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white p-6">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-3xl font-bold">3</span>
                </div>
                <h3 className="text-2xl font-bold">腎臓や肝臓の機能低下を考慮していない薬の量（腎機能・肝機能への配慮不足）</h3>
              </div>
            </div>
            <div className="p-8">
              <div className="mb-6">
                <h4 className="text-xl font-bold text-purple-600 mb-3 flex items-center">
                  <i className="ri-error-warning-fill mr-2"></i>
                  危険性
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  薬の多くは腎臓や肝臓で代謝・排出されます。これらの機能が低下しているのに通常量を服用すると、薬が体外に出ず体内に蓄積し、中毒症状や重篤な副作用を引き起こします。特に高齢者や持病のある方は注意が必要です。
                </p>
              </div>

              <div className="mb-6 bg-teal-50 p-6 rounded-xl">
                <h4 className="text-xl font-bold text-teal-700 mb-3 flex items-center">
                  <i className="ri-user-star-fill mr-2"></i>
                  薬剤師の行動
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  検査データ（あれば）、年齢、過去の既往歴を考慮し、薬の排泄能力を推定。患者さんの機能に見合った「減量」や「変更」の必要性を医師に確認します。一人ひとりの体の状態に合わせた、きめ細やかな調整を行います。
                </p>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl">
                <h4 className="text-xl font-bold text-blue-700 mb-3 flex items-center">
                  <i className="ri-lightbulb-fill mr-2"></i>
                  患者さんへのアドバイス
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  自分の腎臓や肝臓の機能が低下している場合、薬局でその情報を共有することが非常に重要です。健康診断の結果や、医師から言われた注意事項なども、ぜひ薬剤師にお伝えください。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Conclusion */}
        <section className="mb-16">
          <div className="bg-gradient-to-br from-teal-600 to-blue-600 text-white p-10 rounded-2xl shadow-xl">
            <h2 className="text-3xl font-bold mb-6 flex items-center">
              <i className="ri-shield-star-fill text-4xl mr-4"></i>
              薬剤師はあなたの「専属セーフティマネージャー」
            </h2>
            <p className="text-lg leading-relaxed mb-6">
              薬剤師はこれらのチェックを通じて、患者さんの生命の安全を確保し、不安なく治療に専念できるよう貢献しています。お薬手帳は、あなたと薬剤師をつなぐ「命綱」です。
            </p>
            <div className="bg-white/10 p-6 rounded-xl">
              <h3 className="text-xl font-bold mb-4">今日からできること</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-2xl mr-3 flex-shrink-0 mt-1"></i>
                  <span>お薬手帳を必ず持参し、すべての薬局で提示する</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-2xl mr-3 flex-shrink-0 mt-1"></i>
                  <span>複数の病院にかかっている場合は、必ずその旨を伝える</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-2xl mr-3 flex-shrink-0 mt-1"></i>
                  <span>市販薬やサプリメントも含め、すべての服用情報を共有する</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-2xl mr-3 flex-shrink-0 mt-1"></i>
                  <span>体調の変化や気になることがあれば、遠慮なく薬剤師に相談する</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-orange-50 to-red-50 p-8 rounded-2xl border-2 border-orange-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
              薬のことで不安や疑問がありますか？
            </h3>
            <p className="text-gray-700 text-center mb-6 leading-relaxed">
              私たち薬剤師は、いつでもあなたの健康と安全を守るためにここにいます。<br />
              どんな小さなことでも、お気軽にご相談ください。
            </p>
            <div className="flex justify-center">
              <Link 
                to="/contact" 
                className="bg-teal-600 text-white px-8 py-4 rounded-full hover:bg-teal-700 transition-colors text-lg font-medium inline-flex items-center space-x-2 whitespace-nowrap shadow-lg"
              >
                <span>お問い合わせはこちら</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Related Articles */}
        <section>
          <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center">
            <i className="ri-article-line text-teal-600 mr-3"></i>
            関連記事
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            <Link to="/beast-blog/disaster-medication-management" className="group bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300">
              <div className="aspect-video bg-gradient-to-br from-blue-100 to-teal-100 flex items-center justify-center">
                <i className="ri-first-aid-kit-fill text-6xl text-teal-600"></i>
              </div>
              <div className="p-6">
                <h4 className="font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">災害時のお薬管理マニュアル</h4>
                <p className="text-sm text-gray-600">いざという時のために備えておきたい薬の管理方法</p>
              </div>
            </Link>

            <Link to="/beast-blog/elderly-medication-management" className="group bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300">
              <div className="aspect-video bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center">
                <i className="ri-heart-pulse-fill text-6xl text-purple-600"></i>
              </div>
              <div className="p-6">
                <h4 className="font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">高齢者の服薬管理</h4>
                <p className="text-sm text-gray-600">安全で効果的な薬の飲み方をサポート</p>
              </div>
            </Link>

            <Link to="/beast-blog/drug-food-interactions" className="group bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300">
              <div className="aspect-video bg-gradient-to-br from-green-100 to-emerald-100 flex items-center justify-center">
                <i className="ri-restaurant-2-fill text-6xl text-green-600"></i>
              </div>
              <div className="p-6">
                <h4 className="font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">薬と食べ物の相互作用</h4>
                <p className="text-sm text-gray-600">知っておきたい食事と薬の関係</p>
              </div>
            </Link>
          </div>
        </section>
      </article>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center">
                  <i className="ri-capsule-fill text-white text-xl"></i>
                </div>
                <span className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>logo</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                地域の健康を支える、信頼できるパートナー
              </p>
            </div>
            <div>
              <h4 className="font-bold mb-4">サービス</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/services" className="text-gray-400 hover:text-teal-400 transition-colors">サービス一覧</Link></li>
                <li><Link to="/family-pharmacist" className="text-gray-400 hover:text-teal-400 transition-colors">かかりつけ薬剤師</Link></li>
                <li><Link to="/online-medication-guidance" className="text-gray-400 hover:text-teal-400 transition-colors">オンライン服薬指導</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4">情報</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/beast-blog" className="text-gray-400 hover:text-teal-400 transition-colors">ビースト君ブログ</Link></li>
                <li><Link to="/pharmacist-resources" className="text-gray-400 hover:text-teal-400 transition-colors">薬剤師リソース</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4">お問い合わせ</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/contact" className="text-gray-400 hover:text-teal-400 transition-colors">お問い合わせ</Link></li>
                <li><Link to="/privacy-policy" className="text-gray-400 hover:text-teal-400 transition-colors">プライバシーポリシー</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">© 2025 logo. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-teal-400 text-sm transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
